<template>
    <div>
        <keen-message-address-input
            v-model="message.to"
            :disabled="isSending||disabled"
            v-if="!replyMode && !hideToField"
        />

        <ui-textbox
          label="Subject"
          v-model="message.subject"
          :disabled="isSending||disabled"
          v-if="!replyMode"
        />

        <quill-message-field
            ref="editor"
            :value="message.content"
            @input="c => { this.message.content = c }"
            @ready="reset"
            :disabled="isSending||disabled"
        />

        <composer-attachment-pane
            :style="replyMode ? 'margin: 1rem 0;' : 'margin: 1rem 0 2rem;'"
            v-model="message.attachments"
        ></composer-attachment-pane>

        <div class="row" style="margin-top: 1rem;">
            <div class="col">
                <message-box-dropdown-selector
                    v-model="message.message_box"
                    :disabled="isSending||disabled"
                    v-if="!replyMode"
                />
                <ui-icon-button
                    type="secondary"
                    icon="delete"
                    :disabled="isSending||disabled"
                    @click="$emit('reset')"
                    v-if="replyMode"
                />
            </div>
            <div class="col-8 text-right">
                <div class="ui-select-horizontal">
                    <ui-select
                        label="Status:"
                        v-model="assignStatus"
                        :options="statusList"
                        style="margin-bottom: 0;"
                    ></ui-select>
                </div>
                <ui-button
                    icon="send"
                    color="primary"
                    :disabled="disabled"
                    :loading="isSending"
                    @click="send"
                >Send</ui-button>
            </div>
        </div>
    </div>
</template>

<script>
    import MessageBoxDropdownSelector from "./MessageBoxDropdownSelector";
    import KeenMessageAddressInput from "./KeenMessageAddressInput";
    import {ConversationResource, MessageTypes} from "../../classes/Api/Inbox";
    import QuillMessageField from "./QuillMessageField";
    import ComposePaneBase from "./ComposePaneBase";
    import DocumentPickerModal from "../elements/DocumentPickerModal";
    import ComposerAttachmentPane from "./ComposerAttachmentPane";

    export default {
        extends: ComposePaneBase,
        components: {
            ComposerAttachmentPane,
            DocumentPickerModal,
            QuillMessageField,
            KeenMessageAddressInput,
            MessageBoxDropdownSelector
        },
        created() {
            this.message.content = this.defaultContent
        },
        methods: {
            onReset() {
                this.message.content = this.defaultContent
            }
        },
        computed: {
            defaultContent() {
                return window.marque.ui.signatures.email
            },
            messageMedium() {
                return MessageTypes.TYPE_EMAIL
            },
            messageRecipients() {
                return this.message.to.email ?
                    this.message.to.email : this.message.to.primary_display_as
            }
        }
    }
</script>